import {
    AfterViewInit,
    Component,
    ElementRef,
    ViewChild,
    Input,
    OnInit,
} from '@angular/core';
import * as ace from 'ace-builds';
import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/theme-monokai';
const themeGithub: string = 'node_modules/highlight.js/styles/github.css';
const themeAndroidStudio: string =
    'node_modules/highlight.js/styles/androidstudio.css';
@Component({
    selector: 'app-ace-editor',
    templateUrl: './ace-editor.component.html',
    styleUrls: ['./ace-editor.component.scss'],
})
export class AceEditorComponent implements OnInit, AfterViewInit {
    @ViewChild('editor') private editor: ElementRef<HTMLDivElement>;
    @Input() code: string;
    @Input() language: string;
    showCopied: boolean = false;
    currentTheme: string = themeGithub;
    codeBlockHeight: string = 'auto';
    constructor() {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        const aceEditor = ace.edit(this.editor.nativeElement);
        aceEditor.setFontSize('12px');
        aceEditor.session.setValue(this.code);
        if (this.language) {
            import(`ace-builds/src-noconflict/mode-${this.language}`)
                .then(() => {
                    aceEditor.session.setMode(`ace/mode/${this.language}`);
                })
                .catch((error) => {});
        }
        aceEditor.renderer.setShowGutter(false);
        aceEditor.setReadOnly(true);
        aceEditor.setTheme('ace/theme/monokai');
        this.calculateCodeBlockHeight(aceEditor);
    }

    copyCode() {
        const editor = ace.edit(this.editor.nativeElement);
        const code = editor.getSession().getValue();
        const textarea = document.createElement('textarea');
        textarea.value = code;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        this.showCopied = true;
        setTimeout(() => {
            this.showCopied = false;
        }, 1000);
        document.body.removeChild(textarea);
    }

    calculateCodeBlockHeight(editor: any) {
        const contentHeight =
            editor.getSession().getScreenLength() * editor.renderer.lineHeight;
        const minHeight = 10; // Set a minimum height
        const calculatedHeight = Math.max(minHeight, contentHeight) + 20;
        // Set the code block's height based on content
        this.codeBlockHeight = calculatedHeight + 'px';
    }
}
